/**
 * Debounce is not a hook, just a function returning a tuple
 * It does not need to be called at the top level of a function
 * and can be called inside of effects
 */

/* eslint @typescript-eslint/no-explicit-any: 0 */
// eslint-disable-next-line import/prefer-default-export
export function debounce(
  fn: (...args: any) => any,
  delay = 100
): [() => void, () => void] {
  let timeout: number;
  function debounced(...args: any): void {
    /**
     * clear any previous timeouts,
     * this will reset the timer on every call to debounced
     */
    window.clearTimeout(timeout);
    timeout = window.setTimeout(() => {
      fn(...args);
    }, delay);
  }
  function clear(): void {
    window.clearTimeout(timeout);
  }
  // return a tuple
  return [debounced, clear];
}
